import React from 'react'

import pleca from '../../resources/pleca.svg';

export const Footer = () => {
    return (
        <div className="custom-footer">
            <p>Este programa es público, ajeno a cualquier partido político. Queda prohibido su uso para fines distintos a los establecidos en el programa.</p>
            <p>Esta información es de uso interno, queda estrictamente prohibido su publicación en medios externos.</p>
            <br />
            <p>* Se cuentan como participantes, aquellos educandos que presentan examen durante la estrategia</p>
            <p>** Son educandos incorporados y reincorporados aquellos activos del 19 al 25 de febrero de 2024 que estuvieron en situación de baja</p>
            <img src={pleca} alt="Pleca de quetzalcoatl" />
        </div>
    )
}
